var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse navbar-ex1-collapse"},[_c('ul',{staticClass:"nav navbar-nav side-nav"},_vm._l((_vm.sections.sectionLevels),function(sectionLevel){return _c('SectionSubMenu',{key:sectionLevel.name,attrs:{"level":sectionLevel}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-682490a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionMenu.vue
// module id = null
// module chunks = 